import React from 'react';
import { cn } from '@/lib/utils';
import { type DashboardSection } from '@/pages/UserDashboard';
import { motion } from 'framer-motion';

interface DashboardNavigationProps {
  sections: DashboardSection[];
  activeSection: string;
  onSectionChange: (sectionId: string) => void;
}

export default function DashboardNavigation({
  sections,
  activeSection,
  onSectionChange
}: DashboardNavigationProps) {
  return (
    <aside className="bg-zinc-900/50 backdrop-blur-sm rounded-xl border border-white/10 p-4 h-fit sticky top-24">
      <h2 className="text-xl font-bold text-white mb-6 px-2">Dashboard</h2>

      <nav className="space-y-1">
        {sections.map((section) => (
          <button
            key={section.id}
            onClick={() => onSectionChange(section.id)}
            className={cn(
              "w-full flex items-center gap-3 px-3 py-2.5 text-left rounded-lg transition-all",
              "hover:bg-zinc-800/70 group relative overflow-hidden",
              activeSection === section.id
                ? "text-white bg-[#FCAA0D]/10 font-medium"
                : "text-zinc-400 font-normal"
            )}
          >
            {/* Indicador de activo */}
            {activeSection === section.id && (
              <motion.div
                layoutId="active-nav-section"
                className="absolute left-0 top-0 bottom-0 w-1 bg-[#FCAA0D] rounded-r-full"
              />
            )}

            {/* Icono */}
            <span className={cn(
              "flex-shrink-0 transition-colors",
              activeSection === section.id ? "text-[#FCAA0D]" : "text-zinc-500 group-hover:text-zinc-300"
            )}>
              {section.icon}
            </span>

            {/* Etiqueta */}
            <span className="text-sm">{section.label}</span>

            {/* Contador de notificaciones - solo para algunas secciones */}
            {section.id === 'notifications' && (
              <span className="ml-auto flex h-5 w-5 items-center justify-center rounded-full bg-[#FCAA0D] text-[10px] font-medium text-black">
                3
              </span>
            )}
          </button>
        ))}
      </nav>

      {/* Banner promocional */}
      <div className="mt-8 p-4 rounded-lg bg-gradient-to-br from-[#FCAA0D]/20 to-zinc-800/50 border border-[#FCAA0D]/20">
        <p className="text-sm text-zinc-300 mb-3">
          ¿Necesitas ayuda con tus máquinas?
        </p>
        <button
          className="w-full py-2 px-3 rounded bg-[#FCAA0D] hover:bg-[#FCAA0D]/90 text-black text-sm font-medium transition-colors"
        >
          Contactar soporte
        </button>
      </div>
    </aside>
  );
}
